<div class="wrapper">
  <div class="emr-page-container">
    <div class="emr-page-title">Medication List</div>
    <div>
      <canvas id="barcode"></canvas>
    </div>
    <div class="btn-container">
      <button
        pButton
        pRipple
        type="button"
        label="New Medication"
        icon="pi pi-plus"
        (click)="openMedicationDialog()"
      ></button>
      <button
        pButton
        pRipple
        type="button"
        label="Import Medications"
        icon="pi pi-upload"
        (click)="openImportMedDialog()"
      ></button>
      <button
        pButton
        pRipple
        type="button"
        label="Download Barcodes"
        icon="pi pi-download"
        [disabled]="!didSelectMeds"
        (click)="downloadBarcodes()"
      ></button>
      <button
        pButton
        pRipple
        type="button"
        class="p-button-danger"
        label="Delete Medications"
        icon="pi pi-trash"
        [disabled]="!didSelectMeds"
        (click)="openDeleteMedicationsDialog()"
      ></button>
    </div>
    <div class="dialog-container">
      <emr-confirmation-dialog
        title="Delete Medication(s)"
        [(display)]="showDeleteMedicationsDialog"
        (dialogClose)="onCloseDeleteMedicationsDialog($event)"
        [confirmDisabled]="!confirmDeleteMedications"
        >
        <p>You are about to delete the following medications:</p>
        <ul>
          @for (med of selectedMedications; track med) {
            <li>{{ med.name }} ({{ med.id }})</li>
          }
        </ul>
        <p>This will also delete these medications for all users.</p>
        <p>Are you sure you would like to continue?</p>
        <p-checkbox
          id="deleteMedicationsConfirmBox"
          [binary]="true"
          [(ngModel)]="confirmDeleteMedications"
          />
        <label class="label-right-of-box" for="deleteMedicationsConfirmBox"
          >I want to delete the above medications.</label
          >
        </emr-confirmation-dialog>
        <emr-file-upload-dialog
          title="Import Medications"
          [(display)]="showImportMedicationsDialog"
          (dialogClose)="onCloseImportMedicationsDialog($event)"
        ></emr-file-upload-dialog>
      </div>

      <p-table
        #medTable
        [value]="medications"
        class="emr-table"
        styleClass="data-table"
        [loading]="isLoading"
        [rowHover]="true"
        [rows]="25"
        [showCurrentPageReport]="true"
        [rowsPerPageOptions]="[25, 50, 100]"
        responsiveLayout="scroll"
        [paginator]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} medications"
        [filterDelay]="0"
        [globalFilterFields]="tableFilterFields"
        selectionMode="multiple"
        [(selection)]="selectedMedications"
        >
        <ng-template #caption>
          <div class="table-header">
            <p-iconfield iconPosition="left" class="ml-auto">
              <p-inputicon>
                <i class="pi pi-search"></i>
              </p-inputicon>
              <input
                pInputText
                type="text"
                (input)="filterTable($event.target)"
                placeholder="Search medications"
                />
            </p-iconfield>
          </div>
        </ng-template>
        <ng-template #header>
          <tr>
            <th style="width: 3rem">
              <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th>
            <th pSortableColumn="name">
              <div class="flex justify-content-between align-items-center">
                Name
                <p-sortIcon field="name"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="name"
                  display="menu"
                  class="ml-auto"
                ></p-columnFilter>
              </div>
            </th>
            <th pSortableColumn="id">
              <div class="flex justify-content-between align-items-center">
                ID
                <p-sortIcon field="id"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="id"
                  display="menu"
                  class="ml-auto"
                ></p-columnFilter>
              </div>
            </th>
            <th pSortableColumn="routes">
              <div class="flex justify-content-between align-items-center">
                Routes
                <p-sortIcon field="routes"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="routes"
                  display="menu"
                  class="ml-auto"
                ></p-columnFilter>
              </div>
            </th>
            <th>
              <div class="flex justify-content-between align-items-center">Actions</div>
            </th>
          </tr>
        </ng-template>

        <ng-template #body let-med>
          <tr class="p-selectable-row">
            @if (isAdmin) {
              <td>
                <p-tableCheckbox [value]="med"></p-tableCheckbox>
              </td>
            }
            <td>
              {{ med.name }}
            </td>
            <td>
              {{ med.id }}
            </td>
            <td>
              {{ med.getRoutes() }}
            </td>
            <td style="text-align: center">
              <button
                pButton
                type="button"
                class="p-button-warning"
                icon="pi pi-pencil"
                pTooltip="Edit Medication"
                (click)="openMedicationDialog(med)"
              ></button>
            </td>
          </tr>
        </ng-template>

        <ng-template #emptymessage>
          <tr>
            <td colspan="8" style="text-align: center; padding: 3rem">
              No medications have been entered. Click the "New Medication" or "Import Medications"
              button to begin!
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
